<template>
  <div class="">
    <div class="row mt-3">
      <div class="col-12">
        <el-select class="select-primary pagination-select block" v-model="selectedStatus"
          placeholder="Selecciona un status">
          <el-option class="select-primary" v-for="status in statuses" :key="status.value" :label="status.label"
            :value="status">
          </el-option>
        </el-select>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12">
        <div class="d-flex justify-content-end">
          <button type="button" class="btn btn-primary block" :disabled="selectedStatus === null || loading"
            @click="changeStatus">GUARDAR</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import StatsCard from "@/components/Cards/StatsCard";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import BackofficeApi from "../../gateways/backoffice-api";

import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
} from "element-ui";

export default {
  name: "starter-page",
  props: {
    showModal: {
      type: Boolean, // Specify the type of the prop
      required: true // If the prop is required or not
    },
    order: {
      type: Object, // Specify the type of the prop
      required: true // If the prop is required or not
    }
  },
  components: {
    StatsCard,
    RouteBreadCrumb,
    flatPicker,
    [Option.name]: Option,
    [Select.name]: Select,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      loading: false,
      selectedStatus: null,
      statuses: [
        {
          "value": 5,
          "label": "PEDIDO LISTO"
        },
        {
          "value": 6,
          "label": "CANCELADO"
        }
      ]
    };
  },
  mounted() {
  },
  computed: {
    host() {
      return process.env.VUE_APP_API_BACKOFFICE_URL.replace("/api/v1/", "");
    },
  },
  watch: {
    showModal: function (newVal, oldVal) {
      if (!newVal) {
        this.selectedStatus = null;
      }
    }
  },
  methods: {
    async changeStatus() {
      if (this.selectedStatus === null) {
        return;
      }

      this.loading = true;

      const path =
        this.host + "/api/v3/foodcourt/orders/status";

      let response = await BackofficeApi.patch(path, {
        id: this.order.id,
        status: this.selectedStatus.value,
      })

      let newOrder = { ...this.order };

      newOrder.status_name = this.selectedStatus.label;
      newOrder.status_tracking_id = this.selectedStatus.value;

      if (response.status === 200) {
        this.$emit('onOrderChange', newOrder);
        this.$emit('closeModal');
      }

      this.loading = false;
    },
  },
};
</script>
<style lang="scss">
.weight {
  width: 30%;
  border: 1px solid black;

  td,
  th,
  tr {
    border: 1px solid black;
  }
}
</style>
<style>
.noMargin {
  margin-bottom: 0rem;
}

.starter-page {
  min-height: calc(100vh - 380px);
}

.recipe img {
  max-width: 100%;
}

p {
  white-space: pre-line
}

@media screen {
  #print {
    display: none;
  }
}

@media print {
  body * {
    visibility: hidden;
  }

  #print,
  #print * {
    visibility: visible;
  }

  #print {
    position: absolute;
    left: 0;
    top: 0;
  }
}

.block {
  width: 100%;
  display: block;
}

@media all and (max-width:480px) {
  .block-sm {
    width: 100%;
    display: block;
  }
}
</style>
